// extracted by mini-css-extract-plugin
module.exports = {"container":"Footer_container__p5i2u","footer":"Footer_footer__2jquS","link":"Footer_link__1vV6d","copyright":"Footer_copyright__1fyl7","space":"Footer_space__NjUF_"};